// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__yEEwD","tabs--v2":"styles_tabs--v2__UZ2xo","skeleton-animation":"styles_skeleton-animation__t8jS2"};